//TODO Удалить после завершения эксперимента CD-41677
import * as React from 'react';

import { SearchType } from '../../../../models/filters/type';
import { filterChange } from './tracking';

import * as s from './newbuilding_type_filter.css';

interface IProps {
  value: string;

  onChange(value: SearchType): void;
}

export const TypeFilterNewbuilding = (props: IProps) => {
  const {value} = props;

  return (
    <div
      className={`${s['c-newbuilding-tabs']}`}
    >
      <button
        type="button"
        className={`${s['c-newbuilding-tabs-button']} ${value === 'buy' && s['c-newbuilding-tabs-active']}`}
        onClick={() => {
          filterChange('sale', 'sale_tab');
          props.onChange('buy');
        }}
      >
        Купить
      </button>
      <button
        type="button"
        className={`${s['c-newbuilding-tabs-button']} ${value === 'rent_long' && s['c-newbuilding-tabs-active']}`}
        onClick={() => {
          filterChange('rent', 'rent_tab');
          props.onChange('rent_long');
        }}
      >
        Снять
      </button>
      <button
        type="button"
        className={`${s['c-newbuilding-tabs-button']} ${value === 'rent_short' && s['c-newbuilding-tabs-active']}`}
        onClick={() => {
          filterChange('daily', 'daily_tab');
          props.onChange('rent_short');
        }}
      >
        Посуточно
      </button>
    </div>
  );
};
